import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Ornament } from './Ornament';
const costs = ['Hours spent searching for stretches and class ideas.', 'Repeating the same hamstring, hip and shoulder routines.', 'Struggling to create variety without losing structure.', 'Beginners needing simpler options while more flexible clients need greater challenge.', 'Good stretches with no clear progression connecting them.', 'Uncertainty about how long to hold, repeat or progress each movement.', 'Difficulty combining static, dynamic and mobility work correctly.', 'Giving corrections on the spot instead of having clear cues ready.', 'Classes that feel disconnected from one week to the next.', 'More time planning and less time teaching.'];
export function PainPoints() {
  return <section className="bg-surface-subtle px-4 py-20 sm:py-28" data-id="element-217" data-mp="3ie4e88i208mx">
      <div className="mx-auto max-w-3xl" data-id="element-218" data-mp="3ncxta5czo7p7">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center" data-id="element-219" data-mp="3nbwfvu8i394b">
          <h2 className="text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-220" data-mp="27t8ib28esnoz">
            Does This Sound <span className="italic text-primary" data-id="element-221" data-mp="23qvh8r4lxdyj">Familiar?</span>
          </h2>
          <Ornament className="mt-5" data-id="element-222" data-mp="1g1j79p1gh1v6" />
          <div className="mt-8 rounded-xl border border-primary/15 bg-surface p-6 text-left text-base leading-7 text-muted-foreground shadow-card sm:p-8" data-id="element-223" data-mp="1g2lwztn1ky9i">
            <p className="font-display text-xl font-semibold text-foreground" data-id="element-224" data-mp="1p2he0f3a3nhg">
              Another stretching class is coming.
            </p>
            <p className="mt-4" data-id="element-225" data-mp="1k2mn4bji6xwe">
              And instead of already knowing exactly what you are going to
              teach, you are going through saved routines, screenshots, videos,
              old notes and previous class ideas trying to build something that
              feels balanced, useful and professional.
            </p>
            <p className="mt-4" data-id="element-226" data-mp="1t7hp6bve4q4s">
              <strong className="font-semibold text-foreground" data-id="element-227" data-mp="1y3q9e3og39it">
                Not because you do not understand stretching.
                <br data-id="element-228" data-mp="2274s523rq3zy" />
                Not because you do not know how to teach.
              </strong>
            </p>
            <p className="mt-4" data-id="element-229" data-mp="2744yle4j58rl">
              But because creating structured classes week after week takes
              time.
            </p>
          </div>
        </motion.div>

        <div className="mt-14" data-id="element-230" data-mp="1eh2550epno87">
          <h3 className="text-center text-2xl font-semibold text-foreground" data-id="element-231" data-mp="1edwehgqfoead">
            And every time you start from zero, the same problems appear:
          </h3>
          <ul className="mt-7 space-y-3" data-id="element-232" data-mp="1o6tyjrb2qbb3">
            {costs.map((cost, index) => <motion.li key={cost} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04
          }} className="flex items-start gap-3 rounded-lg border border-primary/15 bg-surface px-5 py-4 text-sm leading-6 text-foreground" data-id="element-233" data-mp="qpn02zvjust9" data-mpi={index}>
                <XIcon size={17} className="mt-0.5 shrink-0 text-terracotta" aria-hidden="true" data-id="element-234" data-mp="e695527a3974" />
                {cost}
              </motion.li>)}
          </ul>
          <div className="mt-12 border-t border-accent/40 pt-8 text-center" data-id="element-235" data-mp="gxjy1krm5fc">
            <p className="font-display text-3xl font-semibold text-foreground" data-id="element-236" data-mp="euk6ptt8xxf">
              Your experience is <span className="italic text-primary" data-id="element-237" data-mp="3rkm8djo120hl">already there.</span>
            </p>
            <p className="mx-auto mt-3 max-w-xl text-lg font-medium text-muted-foreground" data-id="element-238" data-mp="3mlsw1ukh8fj0">
              What you need is a system that helps you organize it, visualize
              it and teach it faster.
            </p>
          </div>
        </div>
      </div>
    </section>;
}